/**
 * @Author: Jon Lucas
 * @Date:   2017-09-25T11:09:21+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T18:07:26+02:00
 */

import { Component, OnInit, Input } from "@angular/core";

import { AbstractComponent } from "../../abstract-component/abstract.component";

import { BaseDataType } from "../../base-data-type";

import { ServiceLocator } from "../../service-locator";
import { AppService } from "../../app.service";
import { Utils } from "../../util/Utils";

@Component({
    selector: "app-button-list",
    templateUrl: "./button-list.component.html",
    styleUrls: ["./button-list.component.scss"]
})
export class ButtonListComponent extends AbstractComponent {

    public readonly TAG: string = "[ButtonListComponent]";

    @Input() public lang: string;
    @Input() public subtypeId: string;
    @Input() public optionIndex: number;
    @Input() public optionsType: BaseDataType;
    @Input() public componentType: string;

    private dataUrl: string;

    public types: BaseDataType[];
    public selectedTypes: BaseDataType[];

    private _selectedIds: string[];

    constructor() {
        super();
    }

    /**
     * Check if all conditions are filled, to show navigation element.
     *
     * @see {@link README.md#Conditions} for further information.
     * @param pType {BaseDataType}
     */
    public conditionsOptionsValidated(pType: BaseDataType): boolean {
        // console.log(this.TAG, "conditionsOptionsValidated()", this.subtypeId);

        if(this.subtypeId != "belriv-type") {
            return true;
        }

        if(pType.id == 'chene_liege' && this.confDataService.confdata['project-type']['options'].includes('belriv-systeme')) {
            return false;
        }

        return Utils.conditionsOptionsValidated(pType);
    }

    /**
     * Current menu's selected values' or options' ids.
     */
    public get selectedIds(): string[] {
        return this._selectedIds;
    }

    public set selectedIds(pIds: string[]) {
        this._selectedIds = pIds;

        if (this.selectedIds && this.types) {
            this.selectedTypes = this.types.filter(elementType => this.selectedIds.indexOf(elementType.id) !== -1 );

        }
    }

    public getState(pTypeId: string): boolean {

        if (!pTypeId || !this.selectedIds) { return; }

        return (!this.optionIndex && this.selectedIds.indexOf(pTypeId) > -1) || this.selectedIds[this.optionIndex] === pTypeId;

    }

    public onSelect(pElementType: BaseDataType): void {
        console.log(this.TAG, "onSelect()", pElementType.id, this.optionsType);

        const selectedElementId = pElementType.id;

        if (this.optionsType)
        {
            // Get current saved options
            const currentOptions: string[] = this.confDataService.getElementOptions(this.subtypeId);
            console.log(this.TAG, "currentOptions", currentOptions);
            if (currentOptions)
            {
                // If selected option is the actual saved one, return.
                if (this.optionIndex < currentOptions.length && currentOptions[this.optionIndex] === selectedElementId) {
                    return;
                }

                // Replace it.
                if (this.optionIndex < currentOptions.length) {
                    currentOptions[this.optionIndex] = selectedElementId;
                }
                // Create it.
                else {
                    currentOptions.push(selectedElementId);
                }
                this.confDataService.updateElementOptions(this.subtypeId, currentOptions);
            }
            else
            {
                this.confDataService.updateElementOptions(this.subtypeId, [selectedElementId]);
            }
            // Update current selected options
            this.selectedIds = this.confDataService.getElementOptions(this.subtypeId);
        }
        else
        {
            this.confDataService.updateElementValues(this.subtypeId, [selectedElementId]);
            // Update current selected elements
            this.selectedIds = this.confDataService.getElementValues(this.subtypeId);
        }
    }

    public ngOnChanges() {

        if (!this.subtypeId) {
            return;
        }

        console.log(this.TAG, "OPTIONSTYPE", this.optionsType);

        this.dataUrl = this.confDataService.getApiUrl(this.subtypeId);
        if (!this.dataUrl) {
            console.warn(this.TAG, "ngOnChanges() this.dataUrl is undefined in ConfDataService for subtype: ", this.subtypeId);
            return;
        }

        if (this.optionsType) {
            console.log(this.TAG, "OPTION INDEX", this.optionIndex);
            this.types = this.optionsType.values;
            // Get and set current selected options
            this.selectedIds = this.confDataService.getElementOptions(this.subtypeId);
            return;
        }

        this.appService.getData(this.dataUrl).then(
            (types: BaseDataType[]) => {

                this.types = types.filter(type => Utils.conditionsValidated(type));

                if (!this.confDataService.getElementValues(this.subtypeId)
                || this.confDataService.getElementValues(this.subtypeId).length === 0)
                {
                    return;
                }
                // Get and set current selected elements
                this.selectedIds = this.confDataService.getElementValues(this.subtypeId);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/button-list/button-list.component.ts